var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateEditShoppingList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 313,
    height: 224,
    viewBox: "0 0 313 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_156_9774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303 86.2249C303 138.334 202.592 209.5 147.451 209.5C92.3095 209.5 10 124.974 10 72.8654C10 20.7563 92.3095 6.5 147.451 6.5C202.592 6.5 303 34.1159 303 86.2249Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_156_9774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.62 38.5117H151.182V38.8465H174.62V38.5117Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.258 38.7617H167.923V41.8588H168.258V38.7617Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.046 38.7617H157.711V41.8588H158.046V38.7617Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.506 54.582H163.068V54.9169H186.506V54.582Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.765 51.5703H169.43V54.6674H169.765V51.5703Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.977 51.5703H179.642V54.6674H179.977V51.5703Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.644 62.1172H194.207V62.452H217.644V62.1172Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.903 59.1016H200.568V62.1987H200.903V59.1016Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.115 59.1016H210.781V62.1987H211.115V59.1016Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.301 139.793H191.863V140.128H215.301V139.793Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.559 136.781H198.225V139.878H198.559V136.781Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.772 136.781H208.437V139.878H208.772V136.781Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.289 86.0547H151.852V86.3895H175.289V86.0547Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.548 83.043H158.213V86.1401H158.548V83.043Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.76 83.043H168.426V86.1401H168.76V83.043Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.656 126.402H159.218V126.737H182.656V126.402Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.914 123.387H165.58V126.484H165.914V123.387Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.126 123.387H175.792V126.484H176.126V123.387Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.156 114.18H196.718V114.515H220.156V114.18Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.414 111.168H203.08V114.265H203.414V111.168Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.626 111.168H213.292V114.265H213.626V111.168Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.613 150.154H142.713V150.054V135.652V135.552H142.613H106.547L104.902 132.125L104.859 132.035L104.769 132.078L104.511 132.201L104.421 132.244L104.465 132.335L106.214 135.98L106.242 136.037H106.305H142.227V149.669H102.972H102.872V149.769V150.054V150.154H102.972H142.613Z",
    fill: "#2FACFE",
    stroke: "#2FACFE",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.248 157.04C109.902 157.04 111.243 155.699 111.243 154.045C111.243 152.391 109.902 151.051 108.248 151.051C106.594 151.051 105.254 152.391 105.254 154.045C105.254 155.699 106.594 157.04 108.248 157.04Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.765 157.04C139.418 157.04 140.759 155.699 140.759 154.045C140.759 152.391 139.418 151.051 137.765 151.051C136.111 151.051 134.77 152.391 134.77 154.045C134.77 155.699 136.111 157.04 137.765 157.04Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.557 92.305C173.581 92.305 174.411 91.4751 174.411 90.4514C174.411 89.4276 173.581 88.5977 172.557 88.5977C171.533 88.5977 170.703 89.4276 170.703 90.4514C170.703 91.4751 171.533 92.305 172.557 92.305Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.853 131.332H146.926L146.948 131.262L156.818 99.9342L156.818 99.9342L156.877 99.7488L156.918 99.6187H156.781H92.6555H92.5203L92.5599 99.748L102.201 131.261L102.222 131.332H102.296H146.853ZM156.256 100.104L146.57 130.846H102.581L93.1761 100.104H156.256Z",
    fill: "#2FACFE",
    stroke: "#2FACFE",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.374 129.593H104.239L95.7712 101.645H152.095L152.044 101.809L143.374 129.593Z",
    fill: "#2FACFE",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.555 97.0011L157.651 97.0268L157.677 96.9301L159.483 90.1235H170.133H170.233V90.0235V89.7383V89.6383H170.133H159.186H159.109L159.09 89.7126L157.208 96.8057L157.182 96.9023L157.279 96.928L157.555 97.0011Z",
    fill: "#2FACFE",
    stroke: "#2FACFE",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.577 109.273H95.771V109.559H153.577V109.273Z",
    fill: "#2FACFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.266 119.777H98.9854V120.063H150.266V119.777Z",
    fill: "#2FACFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.86 99.8594H124.575V131.087H124.86V99.8594Z",
    fill: "#2FACFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.628 99.8513L135.581 131.078L135.866 131.097L137.913 99.8699L137.628 99.8513Z",
    fill: "#2FACFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.813 99.8525L111.528 99.8711L113.563 131.099L113.848 131.08L111.813 99.8525Z",
    fill: "#2FACFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 157.223H82V157.557H232V157.223Z",
    fill: "#2FACFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.678 42.8591C181.678 42.8591 184.125 49.8244 182.619 50.896C181.113 51.9676 187.702 60.7189 187.702 60.7189L195.609 58.5757L191.279 51.2532C191.279 51.2532 190.714 43.9307 190.714 42.8591C190.714 41.7875 181.678 42.8591 181.678 42.8591Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M181.678 42.8591C181.678 42.8591 184.125 49.8244 182.619 50.896C181.113 51.9676 187.702 60.7189 187.702 60.7189L195.609 58.5757L191.279 51.2532C191.279 51.2532 190.714 43.9307 190.714 42.8591C190.714 41.7875 181.678 42.8591 181.678 42.8591Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.57 92.5103C177.57 92.5103 176.856 101.44 177.57 106.084C178.285 110.727 179.356 123.586 179.356 123.586C179.356 123.586 179.356 147.876 183.286 148.233C187.215 148.59 190.072 148.947 190.43 147.519C190.787 146.09 188.644 145.375 189.715 144.661C190.787 143.947 191.144 141.446 189.715 138.589C188.286 135.731 189.715 106.798 189.715 106.798L196.502 125.015C196.502 125.015 197.216 140.018 197.931 142.161C198.645 144.304 197.216 148.233 199.717 148.59C202.217 148.947 205.075 146.804 206.503 146.09C207.932 145.375 204.36 145.375 205.075 145.018C205.789 144.661 207.932 143.589 207.218 143.232C206.503 142.875 205.789 125.73 205.789 125.73C205.789 125.73 203.824 89.117 201.324 87.6882C198.824 86.2594 197.216 88.7204 197.216 88.7204L177.57 92.5103Z",
    fill: "#27485D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 146.805V149.662C184 149.662 180.785 157.43 184 157.43C187.215 157.43 189.715 158.235 189.715 157.163V147.519L184 146.805Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.075 146.797V149.654C205.075 149.654 208.289 157.422 205.075 157.422C201.86 157.422 199.359 158.227 199.359 157.156V147.511L205.075 146.797Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.679 48.0388C190.23 48.0388 193.108 45.1602 193.108 41.6092C193.108 38.0583 190.23 35.1797 186.679 35.1797C183.128 35.1797 180.249 38.0583 180.249 41.6092C180.249 45.1602 183.128 48.0388 186.679 48.0388Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.714 53.5742C184.714 53.5742 186.5 58.9322 189.358 57.8606L192.216 56.789L197.216 91.0799C197.216 91.0799 193.287 96.795 187.572 93.2231C181.857 89.6511 184.714 53.5742 184.714 53.5742Z",
    fill: "#27485D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.715 52.5027L191.322 49.1094C191.322 49.1094 200.788 53.5743 202.217 55.0031C203.646 56.4319 203.646 58.5751 203.646 58.5751L201.145 67.505C201.145 67.505 201.86 87.1508 201.86 87.8652C201.86 88.5796 204.36 92.5088 202.574 91.08C200.788 89.6512 200.431 88.2224 199.002 90.3656C197.573 92.5088 194.359 95.0092 194.359 95.0092L189.715 52.5027Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.217 78.2227L201.145 88.2242C201.145 88.2242 194.716 93.9393 196.145 94.2965C197.573 94.6537 198.288 93.2249 198.288 93.2249C198.288 93.2249 200.788 95.7253 202.217 94.2965C203.646 92.8677 207.218 79.2942 207.218 79.2942L202.217 78.2227Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.816 32.5217C185.39 32.4708 183.865 32.4456 182.663 33.2137C182.11 33.5992 181.625 34.0739 181.228 34.6185C180.058 36.0982 179.046 37.9599 179.481 39.7958L179.986 39.5988C179.986 40.0889 179.877 40.5728 179.667 41.0155C179.738 40.8088 179.976 41.143 179.913 41.3522L179.356 43.1771C180.271 42.8419 181.408 43.5206 181.548 44.4845C181.611 42.3649 181.831 39.9343 183.55 38.6932C184.418 38.0673 185.515 37.8762 186.571 37.7066C187.545 37.55 188.566 37.4008 189.499 37.7214C190.432 38.0421 191.226 38.9963 191.015 39.9599C191.445 39.8117 191.926 40.1115 192.139 40.5138C192.351 40.916 192.363 41.3906 192.369 41.8455C192.828 42.1696 193.349 41.5261 193.536 40.9966C193.975 39.7537 194.365 38.4306 194.129 37.1339C193.892 35.8372 192.836 34.598 191.518 34.5936C191.678 34.4179 191.763 34.1868 191.756 33.9493L190.669 33.8575C190.945 33.8185 191.199 33.6847 191.387 33.4792C190.95 33.9592 187.521 32.547 186.816 32.5217Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.5 51.4326C186.5 51.4326 183.592 48.5832 182.546 48.7577C181.499 48.9323 180.071 51.4326 180.071 51.4326C180.071 51.4326 171.498 54.2902 171.855 57.1478C172.212 60.0053 176.141 73.936 176.141 73.936C176.141 73.936 179.356 90.7243 176.499 92.5102C173.641 94.2962 190.072 98.9398 190.429 96.7966C190.787 94.6534 191.501 73.2216 190.429 70.0069C189.358 66.7921 186.5 51.4326 186.5 51.4326Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.002 57.1484H203.419C203.419 57.1484 206.503 70.7219 206.861 72.1507C207.218 73.5795 207.932 80.3662 207.575 80.3662C207.218 80.3662 200.074 78.9374 200.074 80.009L199.002 57.1484Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.853 90.7589H181.944C180.294 83.1685 180.156 75.8349 181.944 68.8281H198.853C196.124 75.7088 195.954 82.9923 198.853 90.7589Z",
    fill: "#2FACFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.07 81.4367L180.071 83.5799C180.071 83.5799 189.715 85.0087 189.715 81.0795C189.715 77.1504 180.071 79.2935 180.071 79.2935L176.856 78.2656L175.07 81.4367Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.141 55.0039L171.855 56.0755L168.64 75.0069C168.64 75.0069 167.569 80.0077 169.355 80.3649C171.141 80.7221 176.141 83.5797 176.141 83.5797C176.141 83.5797 176.856 78.2217 178.285 78.2217L174.713 75.3641L176.856 62.8622L176.141 55.0039Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.524 91.582H92.0862V91.9169H115.524V91.582Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7826 88.5664H98.4478V91.6635H98.7826V88.5664Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.995 88.5664H108.66V91.6635H108.995V88.5664Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.727 42.0273H100.289V42.3622H123.727V42.0273Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.365 42.2773H117.031V45.3744H117.365V42.2773Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.153 42.2773H106.818V45.3744H107.153V42.2773Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.332 75.0078H123.894V75.3426H147.332V75.0078Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.97 75.2578H140.635V78.3549H140.97V75.2578Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.758 75.2578H130.423V78.3549H130.758V75.2578Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.488 74.8398H84.0505V75.1747H107.488V74.8398Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.126 75.0898H100.792V78.1869H101.126V75.0898Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9144 75.0898H90.5796V78.1869H90.9144V75.0898Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.613 58.0977H112.176V58.4325H135.613V58.0977Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.872 55.0859H118.537V58.183H118.872V55.0859Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.084 55.0859H128.749V58.183H129.084V55.0859Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_156_9774",
    x: 0,
    y: 0.5,
    width: 313,
    height: 223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.152941 0 0 0 0 0.282353 0 0 0 0 0.364706 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_156_9774"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_156_9774",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_156_9774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 125.218,
    fill: "white",
    transform: "translate(82 32.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateEditShoppingList);
export default __webpack_public_path__ + "static/media/CreateEditShoppingList.edbd5aa86fcb1e95dfde6a2871140e69.svg";
export { ForwardRef as ReactComponent };